var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          staticClass: "optimized-modal",
          attrs: {
            width: 1000,
            "footer-hide": true,
            title: "违约单明细",
            scrollable: true,
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _vm.innerSpin
            ? _c("Spin", {
                staticClass: "enhanced-spinner",
                attrs: { size: "large", fix: "" },
              })
            : _vm._e(),
          _c(
            "Card",
            {
              staticClass: "no-shadow-card",
              attrs: { padding: 0, bordered: false, "dis-hover": true },
            },
            [
              _c("div", { staticClass: "enhanced-toolbar" }, [
                _c(
                  "div",
                  { staticClass: "left-section" },
                  [
                    _c(
                      "Alert",
                      {
                        staticClass: "operation-guide",
                        attrs: { type: "info", "show-icon": "" },
                      },
                      [
                        _vm._v(
                          "\n            双击明细列表选择要处理的产品\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "right-section" }, [
                  _c(
                    "div",
                    { staticClass: "tool-group" },
                    [
                      _c("label", { staticClass: "tool-label" }, [
                        _vm._v("违约方："),
                      ]),
                      _c(
                        "RadioGroup",
                        {
                          staticClass: "radio-group",
                          attrs: { type: "button" },
                          on: { "on-change": _vm.breachingPartyChange },
                          model: {
                            value: _vm.liquidatedDamageModel.breachingParty,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.liquidatedDamageModel,
                                "breachingParty",
                                $$v
                              )
                            },
                            expression: "liquidatedDamageModel.breachingParty",
                          },
                        },
                        [
                          _c(
                            "Radio",
                            {
                              staticClass: "radio-button",
                              attrs: {
                                label: _vm.BREACHING_PARTY_NAME[_vm.SEEDFARM],
                                disabled: !_vm.role(1),
                              },
                            },
                            [_vm._v("苗场")]
                          ),
                          _c(
                            "Radio",
                            {
                              staticClass: "radio-button",
                              attrs: {
                                label: _vm.BREACHING_PARTY_NAME[_vm.CUSTOMER],
                                disabled: !_vm.role(1),
                              },
                            },
                            [_vm._v("客户")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "tool-group" },
                    [
                      _c("label", { staticClass: "tool-label" }, [
                        _vm._v("违约类型："),
                      ]),
                      _c(
                        "RadioGroup",
                        {
                          staticClass: "radio-group",
                          attrs: { type: "button" },
                          on: { "on-change": _vm.typeChange },
                          model: {
                            value: _vm.liquidatedDamageModel.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.liquidatedDamageModel, "type", $$v)
                            },
                            expression: "liquidatedDamageModel.type",
                          },
                        },
                        [
                          _c(
                            "Radio",
                            {
                              staticClass: "radio-button",
                              attrs: {
                                label: 0,
                                disabled:
                                  !_vm.role(1) ||
                                  _vm.liquidatedDamageModel.breachingParty ===
                                    _vm.BREACHING_PARTY_NAME[_vm.SEEDFARM],
                              },
                            },
                            [_vm._v("\n                全部\n              ")]
                          ),
                          _c(
                            "Radio",
                            {
                              staticClass: "radio-button",
                              attrs: {
                                label: 1,
                                disabled:
                                  !_vm.role(1) ||
                                  _vm.liquidatedDamageModel.breachingParty ===
                                    _vm.BREACHING_PARTY_NAME[_vm.SEEDFARM],
                              },
                            },
                            [_vm._v("\n                部分\n              ")]
                          ),
                        ],
                        1
                      ),
                      _vm.role(1) &&
                      _vm.liquidatedDamageModel.breachingParty ===
                        _vm.BREACHING_PARTY_NAME[_vm.SEEDFARM]
                        ? _c("div", { staticClass: "tool-group" }, [
                            _c(
                              "button",
                              {
                                staticClass: "tool-button",
                                on: { click: _vm.double },
                              },
                              [_vm._v("双倍赔偿")]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "content-wrapper" },
                [
                  _c(
                    "Row",
                    { staticClass: "table-section", attrs: { gutter: 24 } },
                    [
                      _c("Col", { attrs: { span: "12" } }, [
                        _c(
                          "div",
                          { staticClass: "table-container" },
                          [
                            _c("h3", { staticClass: "table-title" }, [
                              _vm._v("订单明细"),
                            ]),
                            _c("StandPaginationTable", {
                              ref: "orderDetail",
                              staticClass: "enhanced-table",
                              attrs: {
                                columns: _vm.orderDetail.columns,
                                data: _vm.orderDetail.data,
                                loading: _vm.orderDetail.loading,
                                "table-search": _vm.orderDetail.tableSearch,
                                "table-load-event": _vm.getDepositDetail,
                                summaryLabelField: "productName",
                                summaryFields: [
                                  "orderQuantity",
                                  "depositValue",
                                  "totalAmount",
                                  "deliveryQuantity",
                                ],
                                autoHeight: true,
                                showPage: false,
                                border: "",
                              },
                              on: { "on-row-dblclick": _vm.addLiquidateDamage },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("Col", { attrs: { span: "12" } }, [
                        _c(
                          "div",
                          { staticClass: "table-container" },
                          [
                            _c("h3", { staticClass: "table-title" }, [
                              _vm._v("违约单明细"),
                            ]),
                            _c("StandPaginationTable", {
                              ref: "liquidateDamageTable",
                              staticClass: "enhanced-table",
                              attrs: {
                                columns: _vm.liquidatedDamageDetail.columns,
                                data: _vm.liquidatedDamageDetail.data,
                                loading: _vm.liquidatedDamageDetail.loading,
                                "table-search":
                                  _vm.liquidatedDamageDetail.tableSearch,
                                "table-load-event":
                                  _vm.getLiquidateDamageDetail,
                                summaryLabelField: "productName",
                                summaryFields: [
                                  "depositValue",
                                  "totalAmount",
                                  "liquidatedDamageQuantity",
                                  "liquidatedDamageValue",
                                ],
                                autoHeight: true,
                                showPage: false,
                                border: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "financial-section" }, [
                    _c(
                      "div",
                      { staticClass: "financial-card" },
                      [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("费用信息"),
                        ]),
                        _c(
                          "Row",
                          { staticClass: "amount-row", attrs: { gutter: 24 } },
                          [
                            _c("Col", { attrs: { span: "6" } }, [
                              _c("div", { staticClass: "amount-group" }, [
                                _c("div", { staticClass: "amount-item" }, [
                                  _c("label", { staticClass: "amount-label" }, [
                                    _vm._v("已付定金："),
                                  ]),
                                  _c("span", { staticClass: "amount-value" }, [
                                    _vm._v(_vm._s(_vm.orderModel.paymentSum)),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _c("Col", { attrs: { span: "6" } }, [
                              _c("div", { staticClass: "amount-group" }, [
                                _c("div", { staticClass: "amount-item" }, [
                                  _c("label", { staticClass: "amount-label" }, [
                                    _vm._v("已发定金："),
                                  ]),
                                  _c("span", { staticClass: "amount-value" }, [
                                    _vm._v(
                                      _vm._s(_vm.orderModel.deliveryDeposit)
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "amount-item" }, [
                                  _c("label", { staticClass: "amount-label" }, [
                                    _vm._v("剩余定金："),
                                  ]),
                                  _c("span", { staticClass: "amount-value" }, [
                                    _vm._v(
                                      _vm._s(_vm.orderModel.remainDeposit)
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _c("Col", { attrs: { span: "12" } }, [
                              _c(
                                "div",
                                { staticClass: "amount-input-group" },
                                [
                                  _c("label", { staticClass: "amount-label" }, [
                                    _vm._v("违约金额："),
                                  ]),
                                  _c("InputNumber", {
                                    staticClass: "amount-input",
                                    attrs: {
                                      disabled: !(_vm.role(1) || _vm.role(2)),
                                      min: 0,
                                    },
                                    model: {
                                      value:
                                        _vm.liquidatedDamageModel
                                          .liquidatedDamageValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.liquidatedDamageModel,
                                          "liquidatedDamageValue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "liquidatedDamageModel.liquidatedDamageValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm.liquidatedDamageModel.otherFeeShow
                          ? [
                              _c(
                                "Alert",
                                {
                                  staticClass: "fee-notice",
                                  attrs: { type: "warning", "show-icon": "" },
                                },
                                [
                                  _vm._v(
                                    "\n                包装费和配送费默认退给客户\n              "
                                  ),
                                ]
                              ),
                              _c(
                                "Row",
                                {
                                  staticClass: "fee-row",
                                  attrs: { gutter: 24 },
                                },
                                [
                                  _c(
                                    "Col",
                                    { attrs: { span: "12" } },
                                    [
                                      _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            content: "默认退给客户",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fee-item" },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "fee-label" },
                                                [_vm._v("包装费：")]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "fee-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.orderModel.packageFee
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "Col",
                                    { attrs: { span: "12" } },
                                    [
                                      _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            content: "默认退给客户",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fee-item" },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "fee-label" },
                                                [_vm._v("配送费：")]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "fee-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.orderModel.deliveryFee
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "remark-section" },
                          [
                            _c("label", { staticClass: "remark-label" }, [
                              _vm._v("备注："),
                            ]),
                            _c("Input", {
                              staticClass: "remark-input",
                              attrs: {
                                type: "textarea",
                                rows: 3,
                                placeholder: "请输入备注信息...",
                              },
                              model: {
                                value:
                                  _vm.liquidatedDamageModel
                                    .liquidatedDamageRemark,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.liquidatedDamageModel,
                                    "liquidatedDamageRemark",
                                    $$v
                                  )
                                },
                                expression:
                                  "liquidatedDamageModel.liquidatedDamageRemark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "action-buttons" },
                    [
                      _vm.role(1)
                        ? _c(
                            "Button",
                            {
                              staticClass: "action-btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.saveLiquidatedDamageDetail()
                                },
                              },
                            },
                            [
                              _c("Icon", { attrs: { type: "md-add" } }),
                              _vm._v(" 保存\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.role(2)
                        ? _c(
                            "Button",
                            {
                              staticClass: "action-btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitLiquidatedDamageDetail()
                                },
                              },
                            },
                            [
                              _c("Icon", { attrs: { type: "md-send" } }),
                              _vm._v(" 提交\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.role(3)
                        ? _c(
                            "Button",
                            {
                              staticClass: "action-btn",
                              attrs: { type: "info" },
                              on: {
                                click: function ($event) {
                                  return _vm.saveAndSubmitLiquidatedDamageDetail()
                                },
                              },
                            },
                            [
                              _c("Icon", { attrs: { type: "md-done-all" } }),
                              _vm._v(" 保存并提交\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.role(4)
                        ? _c(
                            "Button",
                            {
                              staticClass: "action-btn",
                              attrs: { type: "warning" },
                              on: {
                                click: function ($event) {
                                  return _vm.auditLiquidatedDamageDetail()
                                },
                              },
                            },
                            [
                              _c("Icon", { attrs: { type: "md-checkmark" } }),
                              _vm._v(" 审核\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.role(5)
                        ? _c(
                            "Button",
                            {
                              staticClass: "action-btn",
                              attrs: { type: "error" },
                              on: {
                                click: function ($event) {
                                  return _vm.close()
                                },
                              },
                            },
                            [
                              _c("Icon", { attrs: { type: "md-close" } }),
                              _vm._v(" 关闭\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("AuditModal", { ref: "auditModal", on: { audit: _vm.audit } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }